export default __webpack_public_path__ + "static/media/customer-offers.c3a66639.jpg";